import {
  Sparkles,
  Building,
  DollarSign,
  Wrench,
  Package,
  Users,
  FileText,
  Lightbulb,
  Vote,
  MessageCircle,
  Zap,
} from "lucide-react";
import React from "react";
import Jarvis from '../../Assets/Image/jarvis-removebg-preview1.png'

export const FeaturesUniverse = React.memo(() => {
  const orbit1 = [
    { name: "Budget Planning", icon: DollarSign, color: "#10b981", delay: 0 },
    { name: "Maintenance", icon: Wrench, color: "#f97316", delay: 120 },
    { name: "Asset Management", icon: Package, color: "#3b82f6", delay: 240 },
  ];

  const orbit2 = [
    { name: "User Management", icon: Users, color: "#a855f7", delay: 0 },
    { name: "Audit", icon: FileText, color: "#6366f1", delay: 120 },
    { name: "Society Management", icon: Building, color: "#eab308", delay: 240 },
  ];

  const orbit3 = [
    { name: "Community Polling", icon: Vote, color: "#ec4899", delay: 0 },
    {
      name: "Society Connects",
      icon: MessageCircle,
      color: "#14b8a6",
      delay: 120,
    },
    { name: "AI Automation", icon: Zap, color: "#8b5cf6", delay: 240 },
  ];

  const [selectedIntegration, setSelectedIntegration] = React.useState("default");

const integrationDetails = {
  "default": "Explore our AI-powered features designed to revolutionize society management. Click on any feature icon to discover how it can transform your community operations.",
  "Budget Planning": "Smart financial management tools that help societies plan, track, and optimize their budgets with real-time insights and forecasting capabilities.",
  "Maintenance": "Streamlined maintenance request tracking and scheduling system ensuring timely resolution of all property-related issues.",
  "Asset Management": "Comprehensive asset tracking and inventory management system for efficient resource allocation and monitoring.",
  "User Management": "Complete management suite for handling member data, communications, and administrative tasks seamlessly.",
  "Audit": "Automated audit trails and compliance reporting to ensure transparency and regulatory adherence.",
  "Society Management": "AI-powered insights and recommendations for improving society operations and resident satisfaction.",
  "Community Polling": "Interactive voting and polling system to gather community feedback and make collective decisions.",
  "Society Connects": "Social networking platform connecting residents, fostering community engagement and collaboration.",
  "AI Automation": "Intelligent automation of routine tasks, notifications, and workflows to enhance operational efficiency."
};

const TypeWriter = ({ text }) => {
  return (
    <span>
      {text.split('').map((char, index) => (
        <span
          key={index}
          className="wave-char"
          style={{
            animationDelay: `${index * 0.03}s`,
          }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </span>
  );
};

  return (
    <div className="d-flex justify-content-between align-items-center">
  {/* Detail Panel */}
            
 <div className="">
          <button className="integrations-badge fs-6">Admin Feature</button>

  <div className="relative" style={{ paddingLeft: '40px' }}>
    <h3
      className="text-3xl font-black mb-10 bg-gradient-to-br from-cyan-300 via-blue-400 to-purple-500 bg-clip-text text-transparent"
      style={{
        // transform: 'perspective(1000px) rotateY(-20deg)',
        transformOrigin: 'left center',
        // textShadow: '0 10px 30px rgba(59, 130, 246, 0.6), 0 20px 60px rgba(6, 182, 212, 0.4)',
        letterSpacing: '0.02em',
        lineHeight: '1.15',
        fontWeight: '900',
        // WebkitTextStroke: '0.5px rgba(96, 165, 250, 0.3)',
        marginBottom: '0.5rem',
      }}
      >
      {selectedIntegration === "default" ? null : selectedIntegration}
    </h3>
    
    <div 
  className="text-slate-200 text-xl leading-loose font-light"
  style={{
    transformOrigin: 'left center',
    // textShadow: '0 4px 12px rgba(148, 163, 184, 0.5), 0 8px 24px rgba(100, 116, 139, 0.3)',
    letterSpacing: '0.085em',
    fontWeight: '200',
    lineHeight: '1.5',
    maxWidth: '480px',
    marginBottom: '2rem',
    minHeight: '190px',
  }}
>
  <TypeWriter key={selectedIntegration} text={integrationDetails[selectedIntegration]} />
</div>
    

  </div>
</div>




    <div className="w-50 flex items-center justify-center"
     style={{height:"600px"}}
    >
      {/* Central Hub */}
      <div className="absolute z-10">
        <img src={Jarvis} className="w-[135px] h-[140px]" alt="Jarvis"/>
      </div>

      {/* Orbit 1 - Clockwise - Inner orbit */}
      {orbit1.map((integration, idx) => (
        <div
          key={`orbit1-${idx}`}
          className="absolute"
          style={{
            animation: `orbit1 25s linear infinite`,
            animationDelay: `${(-integration.delay * 25) / 360}s`,
            width: "0px",
            height: "0px",
            top: "50%",
            zIndex: 999,
          }}
        >
          <div
            className="w-16 h-16 bg-transparent rounded-full flex items-center justify-center border-1 border-white/10 shadow-[inset_0_2px_20px_rgba(0,0,0,0.3)]"
            style={{
              transform: "translate(-50%, -50%)",
              backdropFilter: "blur(10px)"
            }}
            onClick={(e) => {
    e.stopPropagation();
    setSelectedIntegration(integration.name);
  }}
          >
            <div
              className={`bg-gradient-to-br ${integration.color} bg-clip-text text-transparent`}
            >
              <integration.icon
                className="w-8 h-8"
                style={{
                  color: integration.color,
                  filter: `drop-shadow(0 0 8px ${integration.color})`,
                }}
              />
            </div>
          </div>
        </div>
      ))}

      {/* Orbit 2 - Counter-Clockwise - Middle orbit */}
      {orbit2.map((integration, idx) => (
        <div
          key={`orbit2-${idx}`}
          className="absolute"
          style={{
            animation: `orbit2 30s linear infinite`,
            animationDelay: `${(-integration.delay * 30) / 360}s`,
            width: "0px",
            height: "0px",
            // left: "50%",
            top: "50%",
            zIndex: 999,
          }}
        >
          <div
            className="w-16 h-16 bg-transparent rounded-full flex items-center justify-center border-1 border-white/10 shadow-[inset_0_2px_20px_rgba(0,0,0,0.3)]"
            style={{
              transform: "translate(-50%, -50%)",
              backdropFilter: "blur(10px)"
            }}
            onClick={(e) => {
    e.stopPropagation();
    setSelectedIntegration(integration.name);
  }}
          >
            <div
              className={`bg-gradient-to-br ${integration.color} bg-clip-text text-transparent`}
            >
              <integration.icon
                className="w-8 h-8"
                style={{
                  color: integration.color,
                  filter: `drop-shadow(0 0 8px ${integration.color})`,
                }}
              />
            </div>
          </div>
        </div>
      ))}

      {/* Orbit 3 - Clockwise - Outer orbit */}
      {orbit3.map((integration, idx) => (
        <div
          key={`orbit3-${idx}`}
          className="absolute"
          style={{
            animation: `orbit3 35s linear infinite`,
            animationDelay: `${(-integration.delay * 35) / 360}s`,
            width: "0px",
            height: "0px",
            // left: "10%",
            top: "50%",
            zIndex: 999,
          }}
        >
          <div
            className="w-16 h-16 bg-transparent rounded-full flex items-center justify-center border-1 border-white/10 shadow-[inset_0_2px_20px_rgba(0,0,0,0.3)]"
            style={{
              transform: "translate(-50%, -50%)",
              backdropFilter: "blur(10px)"
            }}
            onClick={(e) => {
    e.stopPropagation();
    setSelectedIntegration(integration.name);
  }}
          >
            <div
              className={`bg-gradient-to-br ${integration.color} bg-clip-text text-transparent`}
            >
              <integration.icon
                className="w-8 h-8"
                style={{
                  color: integration.color,
                  filter: `drop-shadow(0 0 8px ${integration.color})`,
                }}
              />
            </div>
          </div>
        </div>
      ))}

      {/* Orbital Paths */}
      <div className="absolute w-[15rem] h-[15rem] border-2 border-slate-500/20 rounded-full bg-gradient-to-br from-slate-700/30 to-transparent"></div>
      <div className="absolute w-[25rem] h-[25rem] border-2 border-slate-500/20 rounded-full bg-gradient-to-br from-slate-700/30 to-transparent"></div>
      <div className="absolute w-[37rem] h-[37rem] border-2 border-slate-500/20 rounded-full bg-gradient-to-br from-slate-700/30 to-transparent"></div>

      <style jsx>{`
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .wave-char {
    display: inline-block;
    opacity: 0;
    animation: wave 0.5s ease-in-out forwards;
  }
  
  @keyframes wave {
    0% {
      opacity: 0;
      transform: translateY(20px) scale(0.8);
    }
    50% {
      transform: translateY(-8px) scale(1.1);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  @keyframes orbit1 {
    from {
      transform: rotate(0deg) translateX(120px) rotate(0deg);
    }
    to {
      transform: rotate(360deg) translateX(120px) rotate(-360deg);
    }
  }
  @keyframes orbit2 {
    from {
      transform: rotate(0deg) translateX(200px) rotate(0deg);
    }
    to {
      transform: rotate(-360deg) translateX(200px) rotate(360deg);
    }
  }
  @keyframes orbit3 {
    from {
      transform: rotate(0deg) translateX(280px) rotate(0deg);
    }
    to {
      transform: rotate(360deg) translateX(280px) rotate(-360deg);
    }
  }
  .animate-fade-in {
    animation: fade-in 0.5s ease-out forwards;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: perspective(1000px) rotateY(-15deg) translateX(50px);
    }
    to {
      opacity: 1;
      transform: perspective(1000px) rotateY(-5deg) translateX(0);
    }
  }

  @keyframes titleFloat {
    from {
      opacity: 0;
      transform: perspective(1000px) rotateY(-15deg) translateZ(50px) translateX(30px);
    }
    to {
      opacity: 1;
      transform: perspective(1000px) rotateY(-8deg) translateZ(50px) translateX(0);
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: perspective(1000px) rotateY(-30deg) translateY(-30px);
    }
    to {
      opacity: 1;
      transform: perspective(1000px) rotateY(-20deg) translateY(0);
    }
  }
`}</style>
    </div>
    </div>
  );
});
